import { render, staticRenderFns } from "./AthletePage.vue?vue&type=template&id=dab96982&"
import script from "./AthletePage.vue?vue&type=script&lang=js&"
export * from "./AthletePage.vue?vue&type=script&lang=js&"
import style0 from "./AthletePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AthletePage.vue"
export default component.exports